/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Third_Party_PolicyInputs */

const en_privacy_third_party_policy = /** @type {(inputs: Privacy_Third_Party_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy policy`)
};

const lv_privacy_third_party_policy = /** @type {(inputs: Privacy_Third_Party_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privātuma politika`)
};

/**
* | output |
* | --- |
* | "Privacy policy" |
*
* @param {Privacy_Third_Party_PolicyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_third_party_policy = /** @type {((inputs?: Privacy_Third_Party_PolicyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Third_Party_PolicyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_third_party_policy(inputs)
	return en_privacy_third_party_policy(inputs)
});